import { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { PageHero } from '../components/interior/PageElements';
import { legalDocuments } from '../data/legal';

export default function LegalPage({ documentKey }) {
  const params = useParams();
  const document = legalDocuments[documentKey || params.document];
  useEffect(() => {
    const meta = window.document.createElement('meta'); meta.name = 'robots'; meta.content = 'noindex, nofollow';
    window.document.head.appendChild(meta); return () => meta.remove();
  }, []);
  return <><PageHero eyebrow="DRAFT / OWNER & LEGAL REVIEW REQUIRED" title={document.title} description="Not an approved policy. This draft is provided for review and must not be represented as finalized." breadcrumbs={[{ label: document.title }]} />
    <section className="site-section"><article className="site-container legal-document" data-testid="legal-document">
      <p className="legal-draft-notice" role="note" data-testid="legal-draft-notice">DRAFT — FOR OWNER/LEGAL REVIEW. NOT APPROVED.</p>
      {document.sections.map(([title, text], index) => <section key={title} data-testid={`legal-section-${index}`}><h2>{title}</h2><p>{text}</p></section>)}
      <Link className="text-link" to="/contact/" data-testid="legal-contact">Contact Longhorn Milling</Link>
    </article></section></>;
}